import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';

import { FormPackage } from '../../models/df-package';

@Component({
	selector: 'df-image-box',
	templateUrl: './image-box.component.html',
	styleUrls: ['./image-box.component.scss']
})
export class ImageBoxComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() config: FormGroup;
	@Input() form: FormGroup;

	constructor() {}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngOnInit() {}
}
